import React from "react";
import './RandomButton.css';

class RandomButton extends React.Component
{

    render()
    {
        return(
            <button className="random-button" onClick={this.props.onClick} onBlur={this.props.onBlur} disabled={this.props.disabled}>
                Random
            </button>
        );
    }
}

export default RandomButton;